import { render, staticRenderFns } from "./AlltruePlusInfoModal.vue?vue&type=template&id=3d1bdb64&"
import script from "./AlltruePlusInfoModal.vue?vue&type=script&lang=js&"
export * from "./AlltruePlusInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports